/**
 * Background liturgical colors color-wheel matched to Sing Your Part branding.
 */
export const SYP_LITURGICAL_BGCOLORS = {
  blue: '#bbe0ff',
  white: '#ffffff',
  green: '#beffbb',
  purple: '#d9bbff',
  red: '#ffbbbe',
  black: '#000000',
};
